/* eslint-disable no-return-assign */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
// import { Acl } from 'modules/common/components/Acl';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { get } from 'session';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import Select from 'react-select';
// import { ucwords } from '../helper';
import ViewSOA from './ViewSOA';
import ViewUpdateBusinessActivityItem from './ViewUpdateBusinessActivityItem';
import ViewUpdateFeeCalculationItem from './ViewUpdateFeeCalculationItem';
import * as actions from '../actions';
import * as c from '../constant';

function ViewUpdateCalculation({
  data,
  getItem,
  formData,
  setFormData,
  updateDelinquentCalculation,
  generateSOA,
  getVetRegistrationList,
  vetRegistrationList,
  updating,
}) {
  const setModal = useContext(ModalContext);
  const calculationDetail = _.get(
    data,
    'included.bplsApplication.attributes.calculation_details'
  );
  const businessActivityList = _.get(data, 'included.bplsBusinessActivities');

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    setFormData({
      ...formData,
      activities: Object.keys(businessActivityList).map(activity => ({
        activity_id: _.get(businessActivityList, `${activity}.id`) || '',
        yearly_gross_amount:
          _.get(
            businessActivityList,
            `${activity}.attributes.yearly_gross_amount`
          ) || '',
      })),
      base_line:
        _.get(data, 'included.bplsBusiness.attributes.base_line') || '',
      veterinary_fee_id:
        _.get(data, 'included.bplsBusiness.attributes.veterinary_fee_id') || '',
      calculation_details: calculationDetail,
    });
  }, []);

  const handleSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      base_line: _.get(formData, 'base_line') || '',
      veterinary_fee_id: _.get(formData, 'veterinary_fee_id') || '',
    };

    updateDelinquentCalculation(_.get(data, 'id'), args, () => {
      generateSOA(_.get(data, 'id'), {}, response => {
        getItem(_.get(data, 'id'));
        setModal({
          isOpen: true,
          content: <ViewSOA data={data} generateAmount={response} />,
          title: 'View e-SOA',
          modalSize: 'modal-xl',
        });
      });
    });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value || '',
    });
  };

  useEffect(() => {
    getVetRegistrationList();
  }, []);

  const handleOnChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const vetRegistrationListOption =
    vetRegistrationList.map(item => ({
      label: _.get(item, 'attributes.veterinary_registration'),
      value: _.get(item, 'id'),
    })) || '';
  vetRegistrationListOption.unshift({label: 'Select', value: '',})

  const validateForm = useFormValidator(formData, {
    base_line: 'required|number',
  });

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form>
        <div>
          <Tabs>
            <TabList>
              <Tab>Calculation Details</Tab>
              <Tab>Yearly Gross Amount</Tab>
            </TabList>
            <TabPanel>
              <div className="p-3">
                <div className="row">
                  <div className="col-6 form-group">
                    <label htmlFor="last_name" className="form-label mb-0">
                      Base Line {validateForm.renderMessage('base_line')}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="base_line"
                      onChange={onChange}
                      value={_.get(formData, 'base_line') || ''}
                    />
                  </div>
                  <div className="col-6 form-group">
                    <label htmlFor="last_name" className="form-label mb-0">
                      Veterinary Registration
                    </label>
                    <Select
                      placeholder="Select"
                      onChange={handleOnChangeSelect('veterinary_fee_id')}
                      options={vetRegistrationListOption}
                      value={
                        vetRegistrationListOption.find(item => {
                          return (
                            `${_.get(formData, 'veterinary_fee_id')}` ===
                            _.get(item, 'value')
                          );
                        }) || ''
                      }
                    />
                  </div>
                </div>
                <hr />
                <div className="row p-2">
                  <div className="col-2">
                    <div className="form-group mb-0">
                      <label className="form-label mb-0">Code</label>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group mb-0">
                      <label className="form-label mb-0">Description</label>
                    </div>
                  </div>
                  <div className="col-1">
                    <div className="form-group mb-0">
                      <label className="form-label mb-0">Year</label>
                    </div>
                  </div>
                  <div className="col-2">
                    <div className="form-group mb-0">
                      <label className="form-label mb-0">Period</label>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group mb-0">
                      <label className="form-label mb-0">Amount</label>
                    </div>
                  </div>
                </div>
                <div className="" style={{ maxHeight: '60vh', overflow: 'hidden scroll' }}>
                  {calculationDetail
                    ? calculationDetail.map((calculationItem, calculationId) => {
                        return (
                          <div key={`${calculationItem.code}`} className="row">
                            <ViewUpdateFeeCalculationItem
                              id={calculationId}
                              data={calculationItem}
                              feeCalculationFormData={formData}
                              setFeeCalculationFormData={setFormData}
                            />
                          </div>
                        );
                      }) || ''
                      : ''}
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="row p-3" style={{ maxHeight: '60vh', overflow:'hidden scroll' }}>
                {businessActivityList
                  ? businessActivityList.map(
                      (businessActivity, businessActivityId) => {
                        return (
                          <div className="col-6" key={`${businessActivity.id}`}>
                            <div className="form-wrapper p-3 mb-3">
                              <label className="form-label">
                                Line of Business:
                              </label>
                              <h4 className="text-primary">
                                <b>
                                  {_.get(businessActivity, 'attributes.name')}
                                </b>
                              </h4>
                              <ViewUpdateBusinessActivityItem
                                id={businessActivityId}
                                data={businessActivity}
                                activityFormData={formData}
                                setActivityFormData={setFormData}
                              />
                            </div>
                          </div>
                        );
                      }
                    )
                  : ''}
              </div>
            </TabPanel>
          </Tabs>
        </div>
        <div className="d-flex justify-content-center align-items-center mt-2">
          <button
            disabled={updating}
            type="button"
            onClick={handleSubmit}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-dark mr-2   "
          >
            <span className="font-weight-bold">Submit</span>
          </button>

          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewUpdateCalculation.propTypes = {
  getItem: PropTypes.instanceOf(Function).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  updateDelinquentCalculation: PropTypes.instanceOf(Function).isRequired,
  generateSOA: PropTypes.instanceOf(Function).isRequired,
  getVetRegistrationList: PropTypes.instanceOf(Function).isRequired,
  vetRegistrationList: PropTypes.instanceOf(Object).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => {
  return {
    item: get(api, `${c.ITEM}.item`) || {},
    vetRegistrationList:
      _.get(api, `${c.GET_VET_REGISTRATION_LIST}.list`) || [],
    updating: api.loading.indexOf(c.UPDATE_DELINQUENT_CALCULATION_DETAIL) > -1,
  };
};

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewUpdateCalculation);
